import React from "react"
import Cookies from "js-cookie"
import { useSelector } from "react-redux"
import { Navigate, Outlet, useLocation } from "react-router-dom"
import MainLayout from "./MainLayout"
import {
  ORGANIZATION_HOME_PATH,
  isOrganizationRoute,
  isOrgOnlyOwnerUser,
  shouldWaitForOrganizationProbe,
} from "../../utils/organizationAccess"
import { getLocalizedPath } from "../../utils/authLanguageRoutes"
import { getAppLanguage } from "../../utils/getAppLanguage"

/**
 * Merchant portal shell: all authenticated users use MainLayout.
 * Org owners get an Organization section in the sidebar; /organization/* is gated separately.
 */
const AuthenticatedLayout = () => {
  const location = useLocation()
  const profileUser = useSelector((state) => state.user.user)
  const isOwner = useSelector((state) => state.organization.isOwner)
  const probeLoading = useSelector((state) => state.organization.probeLoading)
  const token = Cookies.get("token")

  if (
    shouldWaitForOrganizationProbe(
      profileUser,
      token,
      isOwner,
      probeLoading,
    )
  ) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <span className="text-14 text-8C8C80">Loading…</span>
      </div>
    )
  }

  if (
    isOrgOnlyOwnerUser(profileUser, isOwner, token) &&
    !isOrganizationRoute(location.pathname)
  ) {
    return (
      <Navigate
        to={getLocalizedPath(ORGANIZATION_HOME_PATH, getAppLanguage())}
        replace
      />
    )
  }

  return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  )
}

export default AuthenticatedLayout
